import angular from 'angular';
import { AirportService } from "./airport.service";

let AirportModule = angular.module('airportModule', [

])

.service('AirportService', AirportService)

.name;


export default AirportModule;



// WEBPACK FOOTER //
// ./client/app/services/airport/airport.module.js